import {
  recursionRouter
} from "@/common/util"
import allRouter from "@/router/router"
import router from "@/router";
import {
  Json2Tree
} from "@/common/util";

const permission = {
  state: {
    menus: [],
    buttons: [],
    routers: []
  },
  mutations: {
    FETCH_PERMISSION(state, data) {
      state.buttons = data.filter(item => item.type == 3);
      let m = data.filter(item => item.type != 3);
      state.menus = Json2Tree(m, "386170414964943632")
      let MainContainer = allRouter.dynamicRouter.find(v => v.path === '');
      let routes = recursionRouter(data, MainContainer.children); //过滤路由
      allRouter.dynamicRouter[0].redirect = routes.length ? routes[0] : "" //设置默认页
      MainContainer.children = [...routes, ...allRouter.staticRouter];
      router.addRoutes(allRouter.dynamicRouter); //动态添加路由
    }
  },
  actions: {}
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js